import type { RiskPictureItem, RiskPictureKind } from "./risk-picture-model";

export interface RiskPictureMapFilter {
  showIssued: boolean;
  showChance: boolean;
  /** Phenomena the user switched off. Everything else stays visible. */
  hiddenPhenomena: ReadonlySet<string>;
}

/** A day selection restores phenomena but keeps the user's warning-kind switches. */
export const resetRiskPicturePhenomenaFilter = (
  filter: RiskPictureMapFilter,
): RiskPictureMapFilter => ({ ...filter, hiddenPhenomena: new Set() });

export const filterRiskPictureMapItems = (
  items: RiskPictureItem[],
  filter: RiskPictureMapFilter,
): RiskPictureItem[] =>
  items.filter((item) => {
    if (item.kind === "issued" && !filter.showIssued) return false;
    if (item.kind === "chance" && !filter.showChance) return false;
    return !filter.hiddenPhenomena.has(item.phenomenon);
  });

/** Map filter buttons are the seasonal catalog. Out-of-season phenomena are not added. */
export const riskPictureFilterPhenomena = (catalog: readonly string[]): string[] => [
  ...catalog,
];

/** A phenomenon button is usable when the day has an item of a visible kind. */
export const riskPicturePhenomenonAvailable = (
  items: RiskPictureItem[],
  phenomenon: string,
  filter: Pick<RiskPictureMapFilter, "showIssued" | "showChance">,
): boolean =>
  items.some((item) => item.phenomenon === phenomenon && kindVisible(item.kind, filter));

const kindVisible = (
  kind: RiskPictureKind,
  filter: Pick<RiskPictureMapFilter, "showIssued" | "showChance">,
): boolean => (kind === "issued" ? filter.showIssued : filter.showChance);
